/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { IJobArea } from '../models/job-area.model';

export class LoadJobAreas {
  static readonly type = '[Job Area] Load Job Areas via Service';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadAllJobAreas {
  static readonly type = '[Job Area] Load All Job Areas via Service';
}

export class LoadJobAreaById {
  static readonly type = '[Job Area] Load Job Area by ID via Service';
  constructor(public id: string) {}
}

export class CreateJobArea {
  static readonly type = '[Job Area] Create Job Area via Service';
  constructor(public jobArea: IJobArea) {}
}

export class UpdateJobArea {
  static readonly type = '[Job Area] Update Job Area via Service';
  constructor(public jobArea: IJobArea) {}
}

export class DeleteJobArea {
  static readonly type = '[Job Area] Delete Job Area via Service';
  constructor(public id: string) {}
}

export class ClearCurrentJobArea {
  static readonly type = '[Job Area] Clear Current Job Area';
}
